let blogSearchData = {};

blogSearchData.intervalId = null;

function searchArticle(string) {
    const loadMoreButton = document.querySelector('.load-more-button');
    let articles;

    string = string.toLowerCase();

    if (blogSearchData.intervalId) {
        clearInterval(blogSearchData.intervalId);
    }
    blogSearchData.intervalId = setInterval(() => {
        if (loadMoreButton.disabled)
            return;

        if (loadMoreButton.style.display !== 'none') {
            loadMoreButton.click();
        } else {
            clearInterval(blogSearchData.intervalId);
            blogSearchData.intervalId = null;
            articles = document.querySelectorAll('article.blog-post');
            articles.forEach(article => {
                const title = article.querySelector('h2').innerText.toLowerCase();
                const content = article.querySelector('.excerpt').innerText.toLowerCase();
                if (string != "" && !(title.includes(string) || content.includes(string))) {
                    article.style.display = "none";
                }
                else {
                    article.style.display = "";
                }
            });
        }
    }, 0);

}

document.querySelector('.input-bar input').addEventListener('input', (event) => {
    searchArticle(event.target.value);
});